import { z } from "zod";

export const OAuthProviderSchema = z.enum(["microsoft"]);
